import { render, staticRenderFns } from "./SurveyQuestionEditorParentCounselWeek.vue?vue&type=template&id=5dc5ca48&scoped=true"
import script from "./SurveyQuestionEditorParentCounselWeek.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionEditorParentCounselWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc5ca48",
  null
  
)

export default component.exports